import { FiscalCalendar, FiscalCalendarParams } from '@humalytix/calendar-ts/fiscal-calendar';
import { createSelector } from '@ngrx/store';

import { CompanyFiscalCalendarSettings } from '@ninety/mobile/platform/api';

import { CompanyUserSelectors } from '../../app-entities/company-users/company-users-state.selectors';
import { CurrentUserSelectors } from '../../app-entities/user-list/user-list-state.selectors';

export const selectFiscalCalSettings = createSelector(
  CompanyUserSelectors.selectCurrentCompany,
  (company): CompanyFiscalCalendarSettings | undefined => company?.settings?.fiscalCalendar
);

export const selectFiscalCalParams = createSelector(
  selectFiscalCalSettings,
  CurrentUserSelectors.selectCurrentUserTimezone,
  (settings, timezone): FiscalCalendarParams => {
    const opts: Partial<FiscalCalendarParams> = {
      userTimezone: timezone ?? 'UTC',
      startMonth: settings?.startMonth ?? 0,
      isForward: settings?.isForward ?? false,
    };

    return new FiscalCalendarParams(opts);
  }
);

export const selectFiscalCalendar = createSelector(
  selectFiscalCalParams,
  (params: FiscalCalendarParams): FiscalCalendar => new FiscalCalendar(params)
);
